/**
 * @generated SignedSource<<5df0e03968781a5d7210cb129234d4e2>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847

import type { ConcreteRequest } from 'relay-runtime';
export type WebPanelLocationQuery$variables = {
  contentId?: string | null | undefined;
  location?: string | null | undefined;
  locations?: ReadonlyArray<string | null | undefined> | null | undefined;
  spaceKey?: string | null | undefined;
};
export type WebPanelLocationQuery$data = {
  readonly webPanels: ReadonlyArray<{
    readonly completeKey: string | null | undefined;
    readonly html: string | null | undefined;
    readonly label: string | null | undefined;
    readonly location: string | null | undefined;
    readonly moduleKey: string | null | undefined;
    readonly name: string | null | undefined;
    readonly weight: number | null | undefined;
  } | null | undefined> | null | undefined;
};
export type WebPanelLocationQuery = {
  response: WebPanelLocationQuery$data;
  variables: WebPanelLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "location"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locations"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "location",
        "variableName": "location"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "locations"
      }
    ],
    "concreteType": "WebPanel",
    "kind": "LinkedField",
    "name": "webPanels",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "moduleKey"
      },
      {
        "kind": "ScalarField",
        "name": "completeKey"
      },
      {
        "kind": "ScalarField",
        "name": "html"
      },
      {
        "kind": "ScalarField",
        "name": "location"
      },
      {
        "kind": "ScalarField",
        "name": "label"
      },
      {
        "kind": "ScalarField",
        "name": "weight"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WebPanelLocationQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "WebPanelLocationQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8b133e3996bec5b3feff733a500f3451",
    "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
    "metadata": {},
    "name": "WebPanelLocationQuery",
    "operationKind": "query",
    "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
  }
};
})();

(node as any).hash = "c9e0e68be80f814df706b6c0d828dae1";

export default node;
